import data from './changelog.json'

export const WHATS_NEW_VERSION = data.WHATS_NEW_VERSION
export const CHANGELOG = data.CHANGELOG

// Changelog copy is authored by us, but hrefs still go through this allowlist
// so a bad JSON edit cannot turn a What's New link into an open redirect.
const ALLOWED_HREFS = new Set(['/privacy-policy', '/terms-of-service'])

/**
 * Turns a changelog description into renderable parts.
 * A string stays one text part. An array may mix strings with
 * `{ text, href }` objects for in-app pages.
 *
 * @param {string|Array<string|{text: string, href: string}>} description
 * @return {Array<{type: 'text', value: string}|{type: 'link', text: string, href: string}>}
 */
export const changelogDescriptionParts = (description) => {
  const asText = (value) => (
    typeof value === 'string' && value.length > 0
      ? [{ type: 'text', value }]
      : []
  )

  const asLink = (part) => {
    if (!part || typeof part !== 'object') return []
    const text = typeof part.text === 'string' ? part.text.trim() : ''
    const href = typeof part.href === 'string' ? part.href : ''
    if (!text || !ALLOWED_HREFS.has(href)) return []
    return [{ type: 'link', text, href }]
  }

  if (typeof description === 'string') return asText(description)
  if (!Array.isArray(description)) return []
  return description.flatMap((part) => (
    typeof part === 'string' ? asText(part) : asLink(part)
  ))
}
